import { render, staticRenderFns } from "./timezone.vue?vue&type=template&id=6063d0e8&scoped=true"
import script from "./timezone.vue?vue&type=script&lang=js"
export * from "./timezone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063d0e8",
  null
  
)

export default component.exports